<template>
  <custom-modal v-if="vg_active" :size="'max-w-3xl'">
    <template v-slot:maincontent>
        <div class="mt-4 p-4 text-[14px] bg-theme-modalbg rounded-lg">
          <div class="relative">
            <h2 class="text-2xl text-white text-center pr-[40px]" v-html="vg_msg"></h2>
            <span class="absolute right-1 top-1 pointer cursor-pointer hover:opacity-60"  @click.prevent="reject()">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z" fill="white"/>
              </svg>
            </span>
          </div>
          
          <div class="m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg rounded py-2 px-2 pb-4">
            <div class="full justify-content-center">
              <p class="text-center text-white text-md mt-2">{{vg_extraMsg}}</p>
            </div>
            <div class="full flex">
              <button @click.prevent="accept()" class="uppercase text-white bg-theme-green hover:bg-theme-darkgreen w-3/5 mt-6 text-lg border-0 rounded-md p-2 block mx-auto">CONFIRM</button>
            </div>
          </div>
         
          <div class="mt-3 mb-1 text-center">
            <button @click.prevent="reject()" class="text-white hover:text-theme-green text-center">CLOSE</button>
          </div>
        </div>
        
    </template>
  </custom-modal>
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import {mapGetters, mapMutations} from 'vuex'

export default defineComponent({
    setup() {
   
    },
    mounted(){
      this.vm_active(false)
    },
    computed: {
      ...mapGetters({
        vg_active: 'confirm/active',
        vg_msg: 'confirm/msg',
        vg_extraMsg: 'confirm/extraMsg'
      })
    },
    methods: {
      reject(){
        this.vm_reject()
      },
      accept(){
        this.vm_accept()
      },
      ...mapMutations({
        vm_active: 'confirm/active',
        vm_accept: 'confirm/accept',
        vm_reject: 'confirm/reject'
      })
    }
})
</script>
